@if (label.length > 0) {<label class="fu-label">{{label}}</label>}
<div class="drop-zone" [class.crit]="critical" [class.has-files]="files.length > 0 || !!file" [class.disabled]="disable">
  <p-fileUpload
    [files]="files"
    [multiple]="multiple"
    [accept]="accept"
    maxFileSize="100000000000"
    [disabled]="disable"
    (onSelect)="onUpload($event)"
    chooseLabel=" "
    styleClass="drop-zone-upload">
    <ng-template pTemplate="header" let-files let-chooseCallback="chooseCallback">
      <button type="button" class="dz-hit" (click)="choose($event, chooseCallback)" [disabled]="disable" tabindex="-1" aria-hidden="true"></button>
    </ng-template>
    <ng-template pTemplate="content" let-files>
      @if (!(files?.length > 0) && !file) {
        <div class="dz-empty" (click)="!disable && triggerChoose()">
          <div class="dz-icon">⤓</div>
          <div class="dz-main">Trascina o premi qui per caricare i file</div>          
        </div>
      } @else {
        <div class="dz-files">
          @for (f of (files?.length ? files : (file ? [file] : [])); track f.name + f.size) {
            <div class="dz-file">
              <span class="dz-file-name">{{ f.name }}</span>
              <span class="dz-file-size">{{ formatSize(f.size) }}</span>
              <button type="button" class="dz-file-remove" (click)="onRemoveUpload($event, f); $event.stopPropagation()" [disabled]="disable" aria-label="Rimuovi">×</button>
            </div>
          }
          <button type="button" class="dz-add" (click)="triggerChoose()" [disabled]="disable">
            {{ multiple ? '+ Aggiungi altri file' : 'Cambia file' }}
          </button>
        </div>
      }
    </ng-template>
    <ng-template pTemplate="file"></ng-template>
    <ng-template pTemplate="empty"></ng-template>
  </p-fileUpload>
</div>
@if (allowFolder && !disable) {
  <div class="fu-folder-row">
    <input #folderInput type="file" hidden webkitdirectory multiple (change)="onFolderSelected($event)" />
    <button type="button" class="acc-btn acc-btn-ghost" (click)="folderInput.click()">Carica cartella</button>
  </div>
}
